<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div class="mod-acdc__assessCenter">
      <el-form label-position="top"
               :inline="true"
               :model="dataForm">
        <el-row>
          <!-- 经销商 -->
          <el-col :span="6">
            <el-form-item :label="$t('assessment.dealerName')">
              <el-select v-model="dataForm.dealerId"
                         remote
                         clearable
                         filterable
                         reserve-keyword
                         :placeholder="$t('user.input')"
                         :remote-method="parentDealerSearch">
                <el-option v-for="item in parentDealerList"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 姓名 -->
          <el-col :span="6">
            <el-form-item :label="$t('user.name')">
              <el-input v-model="dataForm.userName"
                        clearable
                        :placeholder="$t('assessment.userInput')"></el-input>
            </el-form-item>
          </el-col>
          <!-- 评估职位 -->
          <el-col :span="6">
            <el-form-item :label="$t('assessment.positionName')">
              <el-select v-model="dataForm.positionId"
                         clearable
                         :placeholder="$t('user.select')">
                <el-option v-for="(item,index) in keyPositionArr"
                           :key="index"
                           :label="item.positionCode + '-' +item.positionName"
                           :value="item.positionId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-col :span="24">
              <el-button style="margin-bottom: 7px"
                         class="M-search"
                         type="primary"
                         @click="query()">{{ $t('query') }}
              </el-button>
            </el-col>
            <el-col :span="24">
              <el-button class="el-back M-search M-margin-l"
                         type="info"
                         @click="reset()">{{ $t('reset') }}
              </el-button>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
      <el-form label-position="top"
               :inline="true">
        <el-row>
          <!-- 区域评估反馈 -->
          <el-col :span="6">
            <el-form-item :label="$t('assessment.regionalInterviewResult')">
              <el-select v-model="dataForm.regionalInterviewResult"
                         clearable
                         :placeholder="$t('user.select')">
                <el-option v-for="(item,index) in regionalInterviewResultArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 发展中心状态 -->
          <el-col :span="6">
            <el-form-item :label="$t('assessment.developCenterState')">
              <el-select v-model="dataForm.developCenterState"
                         clearable
                         :placeholder="$t('user.select')">
                <el-option v-for="(item,index) in developCenterStateArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 评估中心结果 -->
          <el-col :span="6">
            <el-form-item :label="$t('assessment.result')">
              <el-select v-model="dataForm.assessmentResult"
                         clearable
                         :placeholder="$t('user.select')">
                <el-option v-for="(item,index) in assessmentResultArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form label-position="top"
               :inline="true"
               v-show="isShow">
        <el-row>
          <!--经销商集团  -->
          <el-col :span="6">
            <el-form-item :label="$t('assessment.dealerGroupName')">
              <el-select v-model="dataForm.dealerGroupId"
                         remote
                         clearable
                         filterable
                         reserve-keyword
                         :placeholder="$t('user.input')"
                         :remote-method="parentDealerGroupSearch">
                <el-option v-for="item in parentDealerGroupList"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--区域  -->
          <el-col :span="6">
            <el-form-item :label="$t('organization.area')"
                          prop="areaCode">
              <el-select v-model="dataForm.areaCode"
                         :placeholder="$t('user.select')"
                         clearable>
                <el-option v-for="(item,index) in areaArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--评估次数  -->
          <el-col :span="6">
            <el-form-item :label="$t('assessment.assessTimes')">
              <el-select v-model="dataForm.assessTimes"
                         :placeholder="$t('user.select')"
                         clearable>
                <el-option v-for="(item,index) in assessTimesArr"
                           :key="index"
                           :label="item.label"
                           :value="item.assessTimes">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!--品牌  -->
          <el-col :span="6">
            <el-form-item :label="$t('assessment.brand')">
              <el-select v-model="dataForm.brandCode"
                         :placeholder="$t('user.select')"
                         clearable>
                <el-option v-for="(item,index) in brandArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--地点  -->
          <el-col :span="6">
            <el-form-item :label="$t('assessment.site')">
              <el-select v-model="dataForm.siteId"
                         :placeholder="$t('user.select')"
                         clearable>
                <el-option v-for="(item,index) in OfferingSiteArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--排期编号  -->
           <el-col :span="6">
            <el-form-item :label="$t('assessment.offer')">
              <el-input v-model="dataForm.offeringNumber"
                        clearable
                        :placeholder="$t('assessment.offerNumber')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12"
                  class="row-mar-time">
            <el-form-item :label="$t('assessment.offerTime')"
                          style="width: 100%!important;">
              <el-date-picker v-model="dataForm.offerTime"
                              type="daterange"
                              value-format="yyyy-MM-dd"
                              :start-placeholder="$t('assessment.offerStartTime')"
                              :end-placeholder="$t('assessment.offerEndTime')"
                              :clearable="true"
                              :editable='false'
                              style="width: 90%">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <ToggleDiv @toggle="toggle"></ToggleDiv>
      <div class="search">
        <!-- 测评申请 -->
        <el-button type="primary" v-if="$hasPermission('ACDC0001008')"
                   @click="applyForAssessment()">{{ $t('assessment.application') }}
        </el-button>
        <el-button type="primary"
                   @click="exportHandle()">{{ $t('export') }}</el-button>
      </div>
      <!-- 表格 -->
      <el-table v-loading="dataListLoading"
                :data="dataList"
                border
                style="width: 100%;">
        <!-- 当前经销商 -->
        <el-table-column prop="dealerName"
                         :label="$t('assessment.dealerName')"
                         width="140"
                         header-align="center"
                         :show-overflow-tooltip="true"
                         fixed
                         align="center"></el-table-column>
        <!-- 姓名 -->
        <el-table-column prop="userName"
                         :label="$t('user.name')"
                         width="100"
                         header-align="center"
                         align="center"
                         fixed
                         :show-overflow-tooltip="true"></el-table-column>
        <!-- 评估职位 -->
        <el-table-column prop="positionName"
                         :label="$t('assessment.positionName')"
                         width="110"
                         header-align="center"
                         :show-overflow-tooltip="true"
                         align="center"></el-table-column>
        <!-- 在线测评 -->
        <el-table-column prop="onlineTestStatus"
                         :label="$t('assessment.onlineTestStatus')"
                         header-align="center"
                         align="center"></el-table-column>
        <!-- 区域评估结果 -->
        <el-table-column prop="regionalInterviewResult"
                         :label="$t('assessment.regionalInterviewResult')"
                         width="120"
                         header-align="center"
                         align="center"></el-table-column>
        <!-- 评估中心结果 -->
        <el-table-column prop="assessmentResult"
                         :label="$t('assessment.result')"
                         width="150"
                         header-align="center"
                         align="center"></el-table-column>
        <!-- 员工ID -->
        <el-table-column prop="userCode"
                         :label="$t('user.userID')"
                         width="150"
                         header-align="center"
                         align="center"
                         :show-overflow-tooltip="true"></el-table-column>
        <!-- 员工卡号 -->
        <el-table-column prop="userCardNo"
                         :label="$t('user.userCardNo')"
                         width="150"
                         header-align="center"
                         align="center"
                         :show-overflow-tooltip="true"></el-table-column>


        <!-- 评估次数 -->
        <el-table-column prop="assessTimes"
                         :label="$t('assessment.assessTimes')"
                         width="140"
                         header-align="center"
                         align="center"></el-table-column>


        <!-- 能力评估排期 -->
        <el-table-column prop="startTime"
                         :label="$t('assessment.expertAssessOffer')"
                         width="200"
                         header-align="center"
                         align="center"></el-table-column>
        <!-- 场地 -->
        <el-table-column prop="site"
                         :label="$t('assessment.site')"
                         header-align="center"
                         width="180"
                         :show-overflow-tooltip="true"
                         align="center"></el-table-column>

        <!-- 发展中心状态 -->
        <el-table-column prop="developCenterState"
                         :label="$t('assessment.developCenterState')"
                         width="150"
                         header-align="center"
                         align="center"></el-table-column>  

        <!-- 当前经销商集团 -->
        <el-table-column prop="dealerGroupName"
                         :label="$t('assessment.dealerGroupName')"
                         width="180"
                         header-align="center"
                         :show-overflow-tooltip="true"
                         align="center"></el-table-column>
        <!-- 当前品牌 -->
        <el-table-column prop="brand"
                         :label="$t('assessment.brand')"
                         header-align="center"
                         align="center"></el-table-column>
        <!-- 当前网点类型 -->
        <el-table-column prop="netWorkType"
                         :label="$t('assessment.outletType')"
                         width="120"
                         header-align="center"
                         align="center"></el-table-column>
        <!-- 评估时经销商 -->
        <el-table-column prop="recruitmentDealerName"
                         :label="$t('assessment.recruitmentDealerName')"
                         width="180"
                         header-align="center"
                         :show-overflow-tooltip="true"
                         align="center"></el-table-column>
         <!-- 评估时品牌 -->
        <el-table-column prop="recruitmentBrand"
                         :label="$t('assessment.recruitmentBrand')"
                         width="100"
                         header-align="center"
                         align="center"></el-table-column>
        <!-- 评估时网点类型 -->
        <el-table-column prop="recruitmentNetWorkType"
                         :label="$t('assessment.recruitmentOutletType')"
                         width="120"
                         header-align="center"
                         align="center"></el-table-column>
        <!-- 操作 -->
        <el-table-column fixed="right"
                         align="center"
                         width="200"
                         :label="$t('handle')">
          <template slot-scope="scope">
            <!-- 测评详情 -->
            <span class="el-dropdown-link"
                  @click="viewDetail(scope.row)">{{ $t('assessment.detail') }}</span>
            <el-divider direction="vertical"></el-divider>
            <!-- 任职记录 -->
            <span class="el-dropdown-link"
                  @click="viewRecord(scope.row)">{{ $t('assessment.positionRecord') }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     :total="total"
                     layout="total, sizes, prev, pager, next, jumper"
                     @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle">
      </el-pagination>
    </div>
  </el-card>
</template>

<script>
import ToggleDiv from '@/components/toggle-div'
import mixinViewModule from '@/mixins/view-module'
import { moduleRoutes } from '@/router'
import Vue from 'vue'


export default {
  mixins: [mixinViewModule],
  data() {
    let _this = this
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/acdc/recruitment/queryRecruitmentAssessmentByPage',
        getDataListIsPage: true,
      },
      dataList: [],
      dataListLoading: false,
      assessmentResultArr: this.enums['assessmentResult'],
      areaArr: this.enums['area'], // 所在区域
      brandArr: this.enums['brandCode'], // 职位品牌
      joinPositionStatusArr: this.enums['joinPositionStatus'],
      developCenterStateArr: this.enums['developCenterState'],
      regionalInterviewResultArr: this.enums['regionalInterviewResult'],
      // OnlineTestStatusArr: this.enums['OnlineTestStatus'],
      OfferingSiteArr: this.enums['OfferingSite'],
      isShow: false,
      keyPositionArr: [],
      assessTimesArr: [],
      parentDealerList: [],
      parentDealerGroupList: [],
      dataForm: {
        offerTime: [],
        offerStartTime: '',
        offerEndTime: '',
        roleType: ''
      },
    }
  },
  created() {
    this.$request.get('/sys/commposition/keyPosition')
      .then((res, total, code, data) => {
        this.keyPositionArr = res
        this.keyPositionArr = JSON.parse(JSON.stringify(this.keyPositionArr))
      }).catch((err) => {
        console.log(err)
      })

    this.$request.get('/acdc/recruitment/queryAssessmentType')
      .then((res, total, code, data) => {
        this.assessTimesArr = res
        this.assessTimesArr = JSON.parse(JSON.stringify(this.assessTimesArr))
      }).catch((err) => {
        console.log(err)
      })
    if (this.$hasPermission('ACDC0000001')) {
      this.dataForm.roleType = 'acdcAdmin'
    } else if (this.$hasPermission('ACDC0000002')) {
      this.dataForm.roleType = 'areaManager'
    }
  },

  components: {
    ToggleDiv
  },
  methods: {
    toggle(val) {
      this.isShow = val
    },
    query() {
      this.page = 1
      this.getDataListMerge()
    },
    reset() {
      this.page = 1
      this.dataForm = {
        offerTime: [],
        offerStartTime: '',
        offerEndTime: '',
      }
      this.getDataListMerge()
    },
    // 搜索所属集团
    parentDealerGroupSearch(queryString) {
      this.$request.get('/sys/org/selectOrg',
        {
          orgType: '40',
          name: queryString
        }).then((res, total, code, data) => {
          this.parentDealerGroupList = res
        }).catch((err) => {
          console.log(err)
        })
    },
    // 搜索所属经销商
    parentDealerSearch(queryString) {
      this.$request.get('/sys/org/selectOrg',
        {
          orgType: '50',
          name: queryString
        }).then((res, total, code, data) => {
          this.parentDealerList = res
        }).catch((err) => {
          console.log(err)
        })
    },

    getDataListMerge() {
      this.page = 1
      if (this.dataForm.offerTime !== '' && this.dataForm.offerTime) {
        if (this.dataForm.offerTime.length === 2) {
          this.dataForm.offerStartTime = this.dataForm.offerTime[0]
          this.dataForm.offerEndTime = this.dataForm.offerTime[1]
        }
      } else {
        this.dataForm.offerStartTime = ''
        this.dataForm.offerEndTime = ''
      }
      if (this.$hasPermission('ACDC0000001')) {
        this.dataForm.roleType = 'acdcAdmin'
      } else if (this.$hasPermission('ACDC0000002')) {
        this.dataForm.roleType = 'areaManager'
      }
      this.getDataList()
    },

    applyForAssessment() {
      this.$router.push({
        name: 'acdc-assessmentCenter-assessmentApply'
      })
      this.$eventHub.$emit('assessmentCenter')
    },
    viewDetail(row) {
      this.$router.push({
        name: 'acdc-assessment-assessmentDetail',
        query: {
          recruitmentId: row.id,
          userCode: row.userCode,
          recruitmentPosition: row.positionName
        }
      })
      this.$eventHub.$emit('showViewAssessmentDetail', '')
    },

    viewRecord(row) {
      const userCode = row.userCode
      // console.log(userCode)
      this.$router.push({
        name: 'acdc-employmentRecord-employmentRecord',
        query: { userCode: userCode }
      })
      this.$eventHub.$emit('showViewEmploymentRecord', '')
    },
    // 导出
    exportHandle() {
      this.page = 1
      this.$request.downloadLearning('/acdc/recruitment/export', this.$t('areaManager.export'),
        {
          ...this.dataForm,
          page: this.page,
          limit: -1
        }
      )
      this.getDataListMerge()
    }
  }
}
</script>
<style lang='scss' scope >
.row-mar-time {
  padding-left: 20px;
}
.search {
  margin-bottom: 10px;
}
</style>
